import { PropsWithChildren } from 'react';

import styles from './list.module.css';
import { Check } from '../check';

type ListItemProps = PropsWithChildren<{
  isSelected?: boolean;
}>;
export const ListItem = ({ children, isSelected }: ListItemProps) => (
  <li className={styles.listItem} data-selected={isSelected?.toString()}>
    {children}
    {isSelected && <Check />}
  </li>
);
